"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePricingContext = exports.getPcxtV3 = exports.executeAfterPricingContextEvent = exports["default"] = exports.QUERY_PARAMETERS = exports.EVENTS = exports.COOKIE_DATA = void 0;
// If updated, please REMEMBER to update the mirroring constants in pricing-context-module.js
var COOKIE_NAME = 'PCXT';
var COOKIE_REGEX = new RegExp("(^| )".concat(COOKIE_NAME, "=([^;]+)"));
var SCRIPT_LOADED_EVENT = 'PCXT-V3-ScriptLoaded';
var INITIALIZED_EVENT = 'PCXT-V3-ModuleInitialized';
var CONTEXT_CHANGE_EVENT = 'PCXT-V3-ContextChanged';
var COUPON_CHANGE_EVENT = 'PCXT-V3-CouponCodeChanged';
var VAT_INCLUSIVITY_CHANGE_EVENT = 'PCXT-V3-VatInclusivityChanged';
var DATE_TIME_CHANGE_EVENT = 'PCXT-V3-EffectiveDateTimeChanged';
var VAT_INCLUSIVITY_QUERY_PARAMETER = 'PCXTVATINCLUSIVE';
var DATE_TIME_QUERY_PARAMETER = 'PCXTEFFECTIVEDATETIME';

var windowAndDocumentExist = function windowAndDocumentExist() {
  return typeof window !== 'undefined' && window.document;
};

var COOKIE_DATA = exports.COOKIE_DATA = {
  COOKIE_NAME: COOKIE_NAME,
  COOKIE_REGEX: COOKIE_REGEX
};
var EVENTS = exports.EVENTS = {
  SCRIPT_LOADED_EVENT: SCRIPT_LOADED_EVENT,
  INITIALIZED_EVENT: INITIALIZED_EVENT,
  CONTEXT_CHANGE_EVENT: CONTEXT_CHANGE_EVENT,
  COUPON_CHANGE_EVENT: COUPON_CHANGE_EVENT,
  VAT_INCLUSIVITY_CHANGE_EVENT: VAT_INCLUSIVITY_CHANGE_EVENT,
  DATE_TIME_CHANGE_EVENT: DATE_TIME_CHANGE_EVENT
};
var QUERY_PARAMETERS = exports.QUERY_PARAMETERS = {
  VAT_INCLUSIVITY_QUERY_PARAMETER: VAT_INCLUSIVITY_QUERY_PARAMETER,
  DATE_TIME_QUERY_PARAMETER: DATE_TIME_QUERY_PARAMETER
};

var ignore = function ignore() {};

var registerCustomInitCallback = function registerCustomInitCallback(configuration, callback) {
  if (typeof callback !== 'function') {
    return;
  }

  if (window.document.pcxtV3 && window.document.pcxtV3.isInitialized(configuration.merchantId, configuration.market, configuration.isDevelopmentMode)) {
    callback(window.document.pcxtV3.getPricingContext());
  } else {
    window.document.addEventListener(INITIALIZED_EVENT, function onInit(e) {
      window.document.removeEventListener(INITIALIZED_EVENT, onInit, false);
      callback(e.detail);
    });
  }
};

var callPCMInit = function callPCMInit(configuration) {
  window.document.pcxtV3.init(configuration.merchantId, configuration.market, configuration.isDevelopmentMode)["catch"](ignore);
};

var initializePricingContext = exports.initializePricingContext = function initializePricingContext(configuration, callback) {
  if (!windowAndDocumentExist()) {
    return;
  }

  registerCustomInitCallback(configuration, callback);

  if (window.document.pcxtV3) {
    callPCMInit(configuration);
  } else {
    window.document.addEventListener(SCRIPT_LOADED_EVENT, function callback() {
      window.document.removeEventListener(SCRIPT_LOADED_EVENT, callback, false);
      callPCMInit(configuration);
    });
  }
};

var executeAfterPricingContextEvent = exports.executeAfterPricingContextEvent = function executeAfterPricingContextEvent(event, callback, continueListening) {
  if (typeof callback !== 'function') {
    return;
  }

  if (Object.values(EVENTS).indexOf(event) === -1) {
    console.warn("Event '".concat(event, "' is NOT a valid pricing context event."));
    return;
  }

  if (!windowAndDocumentExist()) {
    return;
  }

  window.document.addEventListener(event, function onEvent(e) {
    if (!continueListening) {
      window.document.removeEventListener(event, onEvent, false);
    }

    callback(e.detail);
  });
};

var getPcxtV3 = exports.getPcxtV3 = function getPcxtV3() {
  if (!windowAndDocumentExist()) {
    return undefined;
  }

  return window.document.pcxtV3;
};

var _default = exports["default"] = {
  COOKIE_DATA: COOKIE_DATA,
  EVENTS: EVENTS,
  QUERY_PARAMETERS: QUERY_PARAMETERS,
  initializePricingContext: initializePricingContext,
  executeAfterPricingContextEvent: executeAfterPricingContextEvent,
  getPcxtV3: getPcxtV3
};